"use client";

import type RtpState from "@casino/legacy/client/features/LiveRtp/modules/shared/helpers/RtpState";
import { ChevronRightIcon } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = { state: RtpState };

const RtpArrow: FC<Props> = ({ state }) => {
  if (state === "hot") {
    return (
      <ChevronRightIcon className="size-4 -rotate-90 text-destructive shrink-0" />
    );
  }
  if (state === "cold") {
    return <ChevronRightIcon className="size-4 rotate-90 text-info shrink-0" />;
  }
  return null;
};

export default RtpArrow;
